@use '@fpsm/cxy-scss' as cxy;

.sidebar {
  grid-area: sidebar;
  display: none;
}
@media screen and (min-width: 801px) {
  .sidebar {
    @include cxy.stack(var(--cxy-spacing-xsm) 0);
    padding-inline-start: var(--cxy-spacing-xsm);
    padding-inline-end: var(--cxy-spacing-3);
    color: var(--cxy-color-text-default-body);
    align-self: start;
    position: sticky;
    top: 82px;
    max-height: calc(100vh - 82px - var(--cxy-spacing-xsm));
    overflow-y: auto;
    overflow-x: hidden;
    scroll-behavior: smooth;
  }
  .sidebar::-webkit-scrollbar-track {
    background: var(--cxy-color-border);
  }
  .sidebar::-webkit-scrollbar-track:hover {
    background-color: var(--cxy-color-border-dark);
  }
}
.sidebar [data-testid='sortby-dropdown'] > label {
  font-size: var(--cxy-fontSize-xl);
  font-weight: var(--cxy-fontWeight-bold);
  color: var(--cxy-color-text-default-body);
}

.infoContainer {
  grid-area: sidebar;
  padding-inline-end: var(--cxy-spacing-xsm);
  color: var(--cxy-color-text-default-body);
  padding: var(--cxy-spacing-xsm);
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.infoContainer.compact {
  padding-inline-end: 0;
  padding-inline-start: 0;
}
@media screen and (min-width: 801px) {
  .infoContainer {
    display: none;
  }
}

.mobileMenuTrigger {
  display: block;
}
@media screen and (min-width: 801px) {
  .mobileMenuTrigger {
    display: none;
  }
}

.availableResults {
  grid-area: state;
  font-weight: var(--cxy-fontWeight-normal);
  line-height: var(--cxy-lineHeight-xs);
  font-size: var(--cxy-fontSize-m);
}
@media screen and (min-width: 801px) {
  .availableResults {
    font-size: var(--cxy-fontSize-l);
    height: 48px;
    display: flex;
    align-items: center;
  }
}
